"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _customerQuery = require("./customerQuery");
Object.keys(_customerQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _customerQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _customerQuery[key];
    }
  });
});
